import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoginRedirectPage } from 'src/app/components/login-wizard/models/login-redirect-page.enum';
import { AuthService } from '../auth.service';

export interface AuthorizationRedirectOptions {
	isAutoAccountRedirect?: boolean;
	preferredPlatformTypeId?: number;
	preferredAccountId?: number;
	preferredEmail?: string;
}

@Injectable({
	providedIn: 'root'
})
export class AccountsService {

	constructor(
		private authService: AuthService,
		private jwt: JwtHelperService
	) { }

	public redirectToUserAccountPage(page: LoginRedirectPage, options: AuthorizationRedirectOptions = { isAutoAccountRedirect: false }): Observable<boolean> {
		return this.authService.isUserAuthenticated()
			.pipe(
				catchError(() => of(false)),
				tap(isAuthenticated => {
					const token = this.jwt.decodeToken();
					const platformTypeId = !!token ? parseInt(token[AuthService.PlatformTypeIdClaim], 10) : null;

					const params = new Map<string, string>();
					params.set('page', page.toString());

					if (options.isAutoAccountRedirect) { params.set('isAutoredirect', 'true'); }
					if (options.preferredAccountId) { params.set('accountId', options.preferredAccountId.toString()); }
					if (options.preferredPlatformTypeId) { params.set('platformTypeId', options.preferredPlatformTypeId.toString()); }
					if (options.preferredEmail) { params.set('email', options.preferredEmail); }
					
					if (isAuthenticated && !!platformTypeId && !isNaN(platformTypeId)) {
						location.href = `${location.origin}/accounts?${this.getQueryParamString(params)}`;
					} else {
						params.set('useMobile', '1');
						location.href = `${location.origin}/login?${this.getQueryParamString(params)}`;
					}
				})
			);
	}

	private getQueryParamString(params: Map<string, string>): string {
		return Array.from(params.entries()).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');
	}
}
